import { useStoreCertificationQuery } from "@shared/data/queries/StoreCertificationQuery/StoreCertification.query";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";

const useCertifications = (skip?: boolean) => {
  const { isCanada } = useSharedGlobalConfig();
  const { data, loading, refetch } = useStoreCertificationQuery({
    fetchPolicy: "cache-and-network",
    skip,
  });

  const {
    isApprovedToSendOrdersToDistributor,
    hasAtLeastOneApprovedCertification,
    hasCertificationsUnderReview,
  } = data?.currentStore || {};

  if (loading) {
    return {
      loading: true,
      isCertified: null,
      certificationsPending: null,
      hasSubmittedCertifications: null,
      refetch: null,
    };
  }

  const getIsCertified = () => {
    if (isCanada) {
      return isCertifiedInCanada();
    } else {
      return isCertifiedInUS();
    }
  };

  const isCertifiedInCanada = () => hasAtLeastOneApprovedCertification;

  const isCertifiedInUS = () => isApprovedToSendOrdersToDistributor;

  const getCertificationPending = () => hasCertificationsUnderReview && !getIsCertified();

  return {
    isCertified: getIsCertified(),
    certificationPending: getCertificationPending(),
    hasSubmittedCertifications: hasCertificationsUnderReview,
    refetch,
    loading,
  };
};

export { useCertifications };
